module.exports = __webpack_public_path__ + "media/images/new-ui-images/icon-6-faad7127ae46e887515c378164e091b0.svg";